import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BusinessPage = lazy(() => import('../pages/business/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/business',
    element: <BusinessPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/legal',
    element: <LegalPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;